var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name === 'accountDetails' || _vm.$route.name === 'PossessionDetails'
    )?_c('router-view'):_c('content-view',{staticClass:"accountList"},[_c('tab-components-vue',{attrs:{"currentNumN":_vm.currentNumN},on:{"tabNumChange":_vm.tabNumChange}}),(_vm.currentNum == 0)?_c('Sortingcenter'):_vm._e(),(_vm.currentNum == 1)?_c('Toxiccenter'):_vm._e(),(_vm.currentNum == 2)?_c('MajorPossession'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }